// extracted by mini-css-extract-plugin
export var cardTitle = "_ih-1";
export var commentBubble = "_ih-e";
export var commentForm = "_ih-a";
export var commentInput = "_ih-b";
export var commentLabel = "_ih-d";
export var commentPrompt = "_ih-9";
export var csatCard = "_ih-0";
export var feedbackSection = "_ih-7";
export var starDisabled = "_ih-6";
export var starEmpty = "_ih-5";
export var starFilled = "_ih-4";
export var starWrapper = "_ih-3";
export var starsContainer = "_ih-2";
export var submittedComment = "_ih-c";
export var thankYouText = "_ih-8";